define('models/zendesk/CategoryCollection',['underscore','ObjectCollection','LocalStorage','app','models/zendesk/CategoryModel'],
    function (_,ObjectCollection,LocalStorage,app,CategoryModel) {
    //
    // Collection Zendesk Category
    //
    return ObjectCollection.extend({

        name:'ZendeskCategoryCollection',
        route:'apiZendeskCategory',
        bundleId:'categories',
        idAttribute:'id',
        model:CategoryModel,

    }).extend(LocalStorage);
});
